import React from 'react';
import { Meta, titles } from '@Pages/Heatmap/HeatmapTooltipHeaders/constants';
import TooltipContent from '@Pages/Heatmap/HeatmapTooltipHeaders/TooltipContent';
import TooltipContentStructure from '@Pages/Heatmap/HeatmapTooltipHeaders/TooltipContentStructure';
import TooltipContentTaxonomy from '@Pages/Heatmap/HeatmapTooltipHeaders/TooltipContentTaxonomy';
import TooltipContentOptionsContainer from '@Pages/Heatmap/HeatmapTooltipHeaders/TooltipContentOptions';

export const getHoverTooltipContent = ({ data, type, onClose }) => {
  const { meta, label } = data || {};
  if (meta === Meta.STRUCTURE) {
    return (
      <TooltipContent header={label} onClose={onClose}>
        <TooltipContentStructure {...data} />
      </TooltipContent>
    );
  }
  return (
    <TooltipContent header={titles[type]} onClose={onClose}>
      <TooltipContentTaxonomy {...data} />
    </TooltipContent>
  );
};

export const getOptionsTooltipContent = ({ params, data, type, isRow, onClose }) => {
  const header = `${isRow ? 'Row' : 'Column'} options`;
  return (
    <TooltipContent header={header} onClose={onClose}>
      <TooltipContentOptionsContainer params={params} data={data} type={type} isRow={isRow} onClose={onClose} />
    </TooltipContent>
  );
};
